import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";


export const newtrunkroom = type => {
  document.title = '新トランクルーム｜トランクルームをお探しなら『ハローストレージ』【公式】';
  return (
	<div className="newtrunkroom">
		<div className="app" id="app">
			<h1 className="sr-only">Home</h1>
			<section className="visual-top">
				<div className="container">
					<div className="visual-top__bg">
						<img src="resource/img/static/newtrunkroom/newtrunkroom_fv1_pc.png" alt="新トランクルーム" className="pc_show"/>
						<img src="resource/img/static/newtrunkroom/newtrunkroom_fv1_sp.png" alt="新トランクルーム" className="sp_show"/>
					</div>
					<div className="visual-top__bg2">
						<div className="item">
							<img src="resource/img/static/newtrunkroom/newtrunkroom_fv2_pc.png" alt="新トランクルーム外観"/>
						</div>
						<div className="item">
						<a href="https://arealink.theta360.biz/t/d32cb214-6798-11ec-b8c7-063b2b63adb9-1" target="_blank" rel="noopener noreferrer"><img src="resource/img/static/newtrunkroom/web_nairan_sp.svg" alt="Web内覧はこちら" className="sp_show"/></a>
						<iframe src="https://arealink.theta360.biz/t/d32cb214-6798-11ec-b8c7-063b2b63adb9-1" frameborder="0"></iframe>
						<a href="https://arealink.theta360.biz/t/d32cb214-6798-11ec-b8c7-063b2b63adb9-1" target="_blank" rel="noopener noreferrer"><img src="resource/img/static/newtrunkroom/web_nairan_pc.svg" alt="Web内覧はこちら" className="pc_show"/></a>
						</div>
					</div>
				</div>
			</section>
			<section className="new5 pc_show">
				<div className="container">
					<h2 className="title"><img src="resource/img/static/newtrunkroom/new5_title.svg" alt="新しいトランクハウスの5つの特徴"/></h2>
				</div>
				<div className="new01_container">
					<div className="container">
						<p className="new01_title"><img src="resource/img/static/newtrunkroom/new01.svg" alt="New01"/></p>
						<p className="new01_title_text">内装</p>
						<p className="new5_title_read">デザイン会社監修のもと、従来の内装から<br/>「<span>スタイリッシュ</span>」「<span>清潔感</span>」をイメージできるような内装にリニューアルいたしました。</p>
						<p className="new01_image"><img src="resource/img/static/newtrunkroom/new01_image.png" alt="内装イメージ"/></p>
					</div>
				</div>
				<div className="new02_container">
					<div className="container rightBlock">
						<p className="new5_title"><img src="resource/img/static/newtrunkroom/new02.svg" alt="New02"/></p>
						<p className="new5_title_text">駐車場完備</p>
						<p className="new5_title_read">トランクルームご利用者様専用の駐車場を完備しています。</p>
					</div>
				</div>
				<div className="new03_container">
					<div className="container">
						<p className="new5_title"><img src="resource/img/static/newtrunkroom/new03.svg" alt="New03"/></p>
						<p className="new5_title_text">空調完備</p>
						<p className="new5_title_read">各階に空調設備を設置しています。<br/>衣類や季節ものの収納にピッタリです。</p>
					</div>
				</div>
				<div className="new04_container">
					<div className="container rightBlock">
						<p className="new5_title"><img src="resource/img/static/newtrunkroom/new04.svg" alt="New04"/></p>
						<p className="new5_title_text">セキュリティ完備</p>
						<p className="new5_title_read">交通系ICカードで開錠可能です。<br/>お持ちのカードをご利用いただけるため、<br/>複数の鍵を持ち歩く必要はありません。</p>
					</div>
				</div>
				<div className="new05_container container">
					<h2 className="title"><img src="resource/img/static/newtrunkroom/new05.svg" alt="NEW05 オプションも充実"/></h2>
					<div className="new05Btn">
						<div className="item">
							<a href="/carrieservice/"><img src="resource/img/static/newtrunkroom/new05Btn_a.svg" alt=""/></a>
						</div>
						<div className="item">
							<a href="/trunkwithrack/"><img src="resource/img/static/newtrunkroom/new05Btn_b.svg" alt=""/></a>
						</div>
					</div>
					<p className="new05_text">等、オプションも充実しています。</p>
				</div>
			</section>
			<section className="new5 sp_show">
				<h2 className="title"><img src="resource/img/static/newtrunkroom/new5_title_sp.svg" alt="新しいトランクハウスの5つの特徴"/></h2>
				<div className="container">
					<div className="new5_text">
						<p className="new5_title"><img src="resource/img/static/newtrunkroom/new01.svg" alt="New01"/></p>
						<p className="new5_title_text">内装</p>
						<p className="new5_title_read">デザイン会社監修のもと、従来の内装から<br/>「<span>スタイリッシュ</span>」「<span>清潔感</span>」をイメージできるような内装にリニューアルいたしました。</p>
						<p className="new01_image"><img src="resource/img/static/newtrunkroom/new01_image01_sp.png" alt="内装イメージ"/></p>
					</div>
				</div>
				<p className="new01_image"><img src="resource/img/static/newtrunkroom/new01_image02_sp.png" alt="Afterイメージ"/></p>
				<div className="container">
					<div className="new5_text">
						<p className="new5_title"><img src="resource/img/static/newtrunkroom/new02.svg" alt="New02"/></p>
						<p className="new5_title_text">駐車場完備</p>
						<p className="new5_title_read">トランクルームご利用者様専用の駐車場を完備しています。</p>
					</div>
				</div>
				<p className="new01_image"><img src="resource/img/static/newtrunkroom/new02_image_sp.png" alt="駐車場完備"/></p>
				<div className="new5_text">
					<div className="container">
					<p className="new5_title"><img src="resource/img/static/newtrunkroom/new03.svg" alt="New03"/></p>
					<p className="new5_title_text">空調完備</p>
					<p className="new5_title_read">各階に空調設備を設置しています。<br/>衣類や季節ものの収納にピッタリです。</p>
					</div>
				</div>
				<p className="new01_image"><img src="resource/img/static/newtrunkroom/new03_image_sp.png" alt="空調完備"/></p>
				<div className="new5_text">
					<div className="container">
						<p className="new5_title"><img src="resource/img/static/newtrunkroom/new04.svg" alt="New04"/></p>
						<p className="new5_title_text">セキュリティ完備</p>
						<p className="new5_title_read">交通系ICカードで開錠可能です。<br/>お持ちのカードをご利用いただけるため、<br/>複数の鍵を持ち歩く必要はありません。</p>
					</div>
				</div>
				<p className="new01_image"><img src="resource/img/static/newtrunkroom/new04_image_sp.png" alt="セキュリティ完備"/></p>
				<div className="new5_text">
					<div className="container">
						<p className="new5_title"><img src="resource/img/static/newtrunkroom/new05_sp.svg" alt="New04"/></p>
						<p className="new5_title_text">オプションも充実</p>
						<p className="new5_title_read">自宅からの荷物移動をワンストップで請け負う「ラクキャリサービス」や、トランクルームに収納ラックを設置する「ラック設置サービス」等、オプションも充実しています。</p>
						<div className="item">
							<a href="/carrieservice/" target="_blank" rel="noopener noreferrer"><img src="resource/img/static/newtrunkroom/new05Btn_a.svg" alt=""/></a>
						</div>
						<div className="item mb30">
							<a href="/trunkwithrack/" target="_blank" rel="noopener noreferrer"><img src="resource/img/static/newtrunkroom/new05Btn_b.svg" alt=""/></a>
						</div>
					</div>
				</div>
			</section>
			<section className="detail_lists">
				<div className="container">
					<h2 className="detail_lists_title">対象物件一覧</h2>
					<h3 className="detail_lists_subtitle">料金・詳しい住所・オープン予定などは<br/><span>詳細ページ</span>をご確認ください。</h3>
					<div className="detail_lists_container">
						<div className="detail_lists_frex">
							<div className="item">
								<a href="https://www.hello-storage.com/chiba/chibashi/inageku/detail/6576/" target="_blank" rel="noopener noreferrer" className="detail_btn bgleft"><span>トランクハウス24稲毛轟町</span> <i className="fas fa-chevron-right Btn-Icon"></i></a>
							</div>
							<div className="item">
								<a href="https://www.hello-storage.com/saitama/kasukabeshi/detail/6596/" target="_blank" rel="noopener noreferrer" className="detail_btn bgleft"><span>トランクハウス24春日部増富</span> <i className="fas fa-chevron-right Btn-Icon"></i></a>
							</div>
							<div className="item">
								<a href="https://www.hello-storage.com/tokyo/adachiku/detail/6590/" target="_blank" rel="noopener noreferrer" className="detail_btn bgleft"><span>トランクハウス24足立鹿浜</span> <i className="fas fa-chevron-right Btn-Icon"></i></a>
							</div>
							<div className="item">
								<a href="https://www.hello-storage.com/tokyo/edogawaku/detail/6591/" target="_blank" rel="noopener noreferrer" className="detail_btn bgleft"><span>トランクハウス24中葛西</span> <i className="fas fa-chevron-right Btn-Icon"></i></a>
							</div>
							<div className="item">
								<a href="https://www.hello-storage.com/tokyo/otaku/detail/6610/" target="_blank" rel="noopener noreferrer" className="detail_btn bgleft"><span>トランクハウス24大田東矢口</span> <i className="fas fa-chevron-right Btn-Icon"></i></a>
							</div>
							<div className="item">
								<a href="https://www.hello-storage.com/kanagawa/hiratsukashi/detail/6611/" target="_blank" rel="noopener noreferrer" className="detail_btn bgleft"><span>トランクハウス24平塚立野町</span> <i className="fas fa-chevron-right Btn-Icon"></i></a>
							</div>
							<div className="item">
								<a href="https://www.hello-storage.com/osaka/ibarakishi/detail/6604/" target="_blank" rel="noopener noreferrer" className="detail_btn bgleft">><span>トランクハウス24茨木郡山</span> <i className="fas fa-chevron-right Btn-Icon"></i></a>
							</div>
							<div className="item">
								<a href="https://www.hello-storage.com/aomori/aomorishi/detail/6622/" target="_blank" rel="noopener noreferrer" className="detail_btn bgleft"><span>トランクハウス24青森古川</span> <i className="fas fa-chevron-right Btn-Icon"></i></a>
							</div>
							<div className="item">
								<a href="https://www.hello-storage.com/osaka/sakaishi/sakaiku/detail/6617/" target="_blank" rel="noopener noreferrer" className="detail_btn bgleft"><span>トランクハウス24堺区昭和通</span> <i className="fas fa-chevron-right Btn-Icon"></i></a>
							</div>
						</div>
					</div>
		

				</div>
			</section>

			<section className="footertel">
				<div className="container footertel_container">
					<div className="footertel_area pc_show">
						<p><img src="resource/img/static/newtrunkroom/footertel_text.svg" alt=""/></p>
						<p className="footertel_tel"><img src="resource/img/static/newtrunkroom/footertel_tel.svg" alt=""/></p>
					</div>
					<div className="sp_show">
						<p className="gohumei">ご不明な点がございましたら、<br/>	お気軽にお問合せください。</p>
						<p class="uketuke"><span>受付時間</span>9:30-18:00</p>
						<p className="footertel_tel"><a href="tel:0120524185"><img src="resource/img/static/newtrunkroom/footer_tel_btn.svg" alt=""/></a></p>
					</div>
				</div>
			</section>
		</div>
	</div>
  );
};



// WEBPACK FOOTER //
// ./pages/static/newtrunkroom.jsx